import { useState } from "react";
import PropTypes from "prop-types";
import { Grid, InputLabel, Box, CircularProgress } from "@material-ui/core";
import translate from "i18n/translate";
import translateIntl from "i18n/translateIntl";
import ApplicationKey from "../ApplicationKey";
import { SrAlert, SrButton, SrDialog, SrInput } from "../../../../common";

const Restore = ({
  data,
  secretKey,
  handleClose,
  onSubmit,
  loading,
  error,
}) => {
  const [showForm, setShowForm] = useState(true);
  const [isValid, setIsValid] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [isTouched, setIsTouched] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const onChange = (evt) => {
    setInputValue(evt.target.value);
    if (evt.target.value.toLowerCase() === "confirmar") {
      setIsValid(true);
    } else if (isValid) {
      setIsValid(false);
    }
  };

  const onBlur = () => {
    setIsTouched(true);
  };

  const onRestoreClick = () => {
    setBtnDisabled(true);
    onSubmit(data.key, setShowForm);
  };

  if (showForm) {
    return (
      <SrDialog
        handleClose={handleClose}
        heading={translate("common.restore")}
        actions={
          <>
            <SrButton onClick={handleClose}>
              {translate("common.cancel")}
            </SrButton>
            <SrButton
              color="primary"
              type="submit"
              variant="contained"
              onClick={onRestoreClick}
              disabled={btnDisabled || !isValid}
            >
              {translate("common.restore")}
            </SrButton>
          </>
        }
      >
        <Box display="flex" flexDirection="column">
          <InputLabel>{translate("applications.word")}:</InputLabel>
          <Box marginTop="20px">
            <SrInput
              autoComplete="off"
              name="enterConfirm"
              placeholder={translateIntl("applications.confirmWord")}
              type="text"
              onChange={onChange}
              onBlur={onBlur}
              value={inputValue}
              error={!isValid && isTouched}
              helperText={
                !isValid && isTouched && translate("applications.invalidWord")
              }
              fullWidth
            />
          </Box>
          {error && (
            <Box marginTop="20px">
              <SrAlert severity="error">{error}</SrAlert>
            </Box>
          )}
        </Box>
      </SrDialog>
    );
  }

  return (
    <SrDialog
      handleClose={handleClose}
      heading={
        loading
          ? translate("applications.restoring")
          : translate("applications.restoredTitle")
      }
    >
      {loading ? (
        <Grid container justifyContent="center">
          <Box margin={2}>
            <CircularProgress />
          </Box>
        </Grid>
      ) : (
        <ApplicationKey
          title={translate("applications.restored")}
          secretKey={secretKey}
        />
      )}
    </SrDialog>
  );
};

Restore.propTypes = {
  data: PropTypes.array.isRequired,
  secretKey: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.string.isRequired,
};

export default Restore;
